import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { peerIpApi } from "../api/peerIp/peerIpApi"
import { getPeerIp } from "#src/modules/reducers/peerIp.js";

const usePeerIp = () => {
  const peerIp = useSelector((state) => state.peerIp.ip);
  const dispatch = useDispatch();
  
  useEffect(() => {
    const api = peerIpApi();
    dispatch(getPeerIp({ ...api }));
  }, []);
  return { getPeerIp, peerIp };
};

export default usePeerIp;
